import {h, Component} from 'preact'

import designService from '../service/designService'

export default class AsideLayouts extends Component {
    constructor() {
        super()
        this.state = {
            isLoading:          false,
            designs:            []
        }
    }

    componentDidMount() {
        this.setState({ isLoading: true })
        designService.getPublicDesigns().then( response => {
            this.setState({ designs: response.data })
            this.setState({ isLoading: false })
        })
    }

    render (props, state) {
        return (
            <div id="app-aside-designs" class="aside-text">
                <div class="scroller no-top">
                </div>
            </div>
        )
    }
}